window.addEventListener('turbolinks:load', () => {
  const localeDropdown = document.querySelector('.locale-selector')
  if (localeDropdown) {
    localeDropdown.addEventListener('click', (event) => {
      event.preventDefault()
      window.location.href = event.target.href
    })
  }
})
